import { colorPalette } from 'styles/css-constants';
import { uppercase } from 'styles/typography/css-mixins';
import { sansSerif } from 'styles/css-constants';
import css from 'styled-jsx/css';

export default css`
  .InlineSearchForm {
    padding: 2rem 0.5rem;
    background-color: ${colorPalette.brand};
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }

  .InlineSearchForm__title {
    margin-bottom: 1rem;
    font-weight: bold;
    text-transform: lowercase;
  }

  .InlineSearchForm__form {
    box-sizing: border-box;
    display: flex;
    margin-bottom: 1.25rem;
    width: 100%;
    max-width: 640px;
    height: 50px;
  }

  .InlineSearchForm__links {
    display: flex;
    padding: 0;
    margin: 0;
    list-style: none;
  }

  .InlineSearchForm__title {
    font-size: var(--fontScale3);
  }

  .InlineSearchForm__link {
    font-size: var(--fontScaleNeg1);
  }

  .InlineSearchForm__input {
    flex: 1 0 0px;
    padding: 0.5rem;
    border: 1px solid #ccc;
    font-size: 16px;
  }

  /* Hide the label when the input is in use */
  .InlineSearchForm__input:focus + .InlineSearchForm__input__label-message {
    display: none;
  }

  .InlineSearchForm__label {
    position: relative;
    flex: 1 0 auto;
    display: flex;
    font-family: ${sansSerif};
    font-size: 16px;
    color: #5b4746;
  }

  .InlineSearchForm__label-message {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    padding-left: 0.5rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .InlineSearchForm__input {
    border: none;
    box-shadow: inset 1px 1px 6px #bbb;
  }

  .InlineSearchForm__submit {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 1rem;
    background-color: #000;
    color: #fff;
    opacity: 0.3;
    mix-blend-mode: multiply;
  }

  .InlineSearchForm__submit {
    font-size: 12.8px;
    text-transform: uppercase;
    letter-spacing: 0.02em;
  }

  @media (min-width: 768px) {
    .InlineSearchForm__submit {
      font-size: 16px;
    }
  }

  .InlineSearchForm__link {
    padding: 0 0.5rem;
    border-right: 2px solid #fff;
    color: #000;
    font-weight: bold;
    ${uppercase}
  }

  .InlineSearchForm__link:last-child {
    border: none;
  }
`;
